import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Loading, Modal, SystemText } from 'e4shared';
import BlobImage from 'components/blobImage';
import posthog from 'posthog-js';

import './users.css';
import { apiGet } from 'services';
import { useSelector } from 'react-redux';
import { ratingColour } from 'helpers/metrics';

export const cellClass = pct => {
    return `grid-${ratingColour(pct)}`;
};

export const CompetencyGridUsers = ({ show, close, competency, loadFromTeam }) => {
    const [mapped, setMapped] = React.useState([]);
    const [loading, setLoading] = React.useState(false);

    const user = useSelector(state => state.user.user);

    const st = (path, ...rest) => SystemText(`Dashboards/CompetencyGrid/Users/${path}`, ...rest);

    React.useEffect(() => {
        if (loadFromTeam) {
            setLoading(true);
            apiGet(`review-team-competencies/${competency.id}`, user.guid, response => {
                setMapped(response);
                setLoading(false);
            });
        } else {
            competency?.people && setMapped(competency.people);
        }
    }, [competency, loadFromTeam]);

    const closeMe = () => {
        close?.();
    };

    if (!competency) return null;

    return (
        <Modal show={show} close={closeMe} title={competency.full_Name} footer={null}>
            <div>
                {loading ? (
                    <Loading />
                ) : (
                    <>
                        {mapped.length === 0 && <p>{st('NoPeople')}</p>}
                        {mapped.map((person, i) => {
                            return (
                                <div key={person.id}>
                                    {i > 0 && <hr />}
                                    <div className="flex flex-top competency-users">
                                        <div
                                            className="mr10"
                                            style={{
                                                padding: '2px',
                                                border: 'solid 1px #ebebeb',
                                                backgroundColor: '#fff',
                                                height: '50px',
                                                width: '50px',
                                            }}
                                        >
                                            <BlobImage height="44" className="" folder="avatar" src={person.avatar} />
                                        </div>
                                        <div
                                            className={`${cellClass(person.level)} mr10`}
                                            style={{ width: '50px', height: '50px' }}
                                        >
                                            <div className="rating">{person.level || 'n/a'}</div>
                                        </div>
                                        <div>
                                            <h4 style={{ marginTop: 0, paddingTop: '3px' }}>
                                                <Link
                                                    onClick={() => posthog.capture('widget-profile-click')}
                                                    to={`/develop/performance-dashboard/${person.id}`}
                                                >
                                                    {person.full_Name}
                                                </Link>
                                            </h4>
                                            <div className="text-sm">
                                                {person.department_Names?.join(', ') || (
                                                    <span className="italic">{st('NoDepartment')}</span>
                                                )}{' '}
                                                | {person.job_Title || <span className="italic">{st('NoJobTitle')}</span>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </>
                )}
            </div>
        </Modal>
    );
};

export default withRouter(CompetencyGridUsers);
